import { render, staticRenderFns } from "./ClientContactForm.vue?vue&type=template&id=23b1d865&"
import script from "./ClientContactForm.vue?vue&type=script&lang=js&"
export * from "./ClientContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactForm.vue?vue&type=style&index=0&id=23b1d865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports